export default {
    dataSource: {
        type: Object,
        default: undefined
    }, 
    filterable: {
        type: Boolean,
        default: undefined
    }, 
    sortable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    height: {
        type: [Number, String],
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }

    // Events
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/KendoPivotConfigurator/PivotConfiguratorProps.js